import axios from 'axios';
import { getInstance } from '@pantheon-systems/auth0-vue-module';

class Api {
  constructor() {
    const self = this;
    self._apiKey = '';
    self._instance = '';
    self._ready = false;
  }

  init(apiKey) {
    const self = this;
    self._apiKey = apiKey;
    self._instance = axios.create({
      baseURL: process.env.VUE_APP_MICROSERVICE_URL,
      timeout: 30000,
      headers: {
        'X-Adv-Cdn-Token': apiKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    self._ready = true;
  }

  async fetch(url, params) {
    const self = this;
    const token = await getInstance().getTokenSilently();
    self._instance.defaults.headers.Authorization = `Bearer ${token}`;
    return self._instance({
      method: 'GET',
      url,
      params,
    });
  }

  async patch(url, data) {
    const self = this;
    const token = await getInstance().getTokenSilently();
    self._instance.defaults.headers.Authorization = `Bearer ${token}`;
    return self._instance({
      method: 'PATCH',
      url,
      data,
    });
  }
}
export default Api;
